<template>
  <v-dialog :key="changeKey" v-model="dialog" @input="v => v || closeDialog()">
    <v-card id="event-card" style="max-height: 500px; overflow-y: auto;" @scroll="bottomVisible">
      <v-card-text class="modal-header">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-3">
          <h3>{{ dialogTitle }}</h3>
        </div>
      </v-card-text>  
      <v-container>
        <v-row dense v-if="eventsData.length">
          <v-col cols="12" v-for="(event, index) in eventsData" :key="event.id + index">
            <h2
              v-if="!compareDates(eventsData[index], eventsData[index - 1])"
              class="md-whiteframe-6dp"
            >
              {{ formatEventDate(event) }}
            </h2>
            <div class="item-detail">
              <v-row class="m-0">
                <v-col md="2" sm="3" class="text-center">
                  <span>{{ showDate(event.storedate) }}</span>
                </v-col>
                <v-col md="2" cols="2" class="text-center">
                  <i :class="[chooseMessage(event), 'icon-large']"></i>
                </v-col>
                <v-col md="8" sm="6">
                  <p>{{`event_messgae_type_${event.messagetype}` | translate }}
                    <span v-if="event.messagetype == '6'">{{ formatSubscriptionTierLabel(event.subtype) }}</span>
                    <span v-if="event.messagetype == '7'">{{ formatContractTierLabel(event.subtype) }}</span>
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row v-else dense>
          <v-col cols="12" class="item-detail d-flex align-center justify-center">
            <span>{{ "lng_no_event_logs_txt" | translate }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalService from "../../services/global-service";
import moment from "moment";
import { translateFunc } from "../../common/Filters.js"
import { formatSubscriptionTierLabel, formatContractTierLabel } from '../../common/HelperFunctions';


export default {
  name: "EventItems",
  data() {
    return {
      dialog: false,
      bottom: false,
      offsetNumber: 0,
      count: 100,
      eventsData: [],
      token: 0,
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    systemId: {
      type: String,
      default: null,
    },
    userToken: {
      type: String,
      default: ""
    },
    changeKey: {
      type: Number,
      default: 0
    },
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
      if (newVal && this.systemId) {
        this.resetAndFetch(this.systemId);
      }
    },
    bottom(bottom) {
      if (bottom) {
        this.offsetNumber += 100;
        this.fetchEventsData(this.systemId);
      }
    }
  },
  created() {
    // window.addEventListener("scroll", () => {
    //   this.bottom = this.bottomVisible();
    // });
  },
  mounted() {},
  methods: {
    formatSubscriptionTierLabel,
    formatContractTierLabel,
    resetAndFetch(sysId) {
      this.offsetNumber = 0;
      this.eventsData = [];
      this.fetchEventsData(sysId);
    },
    bottomVisible() {
      const wrappedElement = document.getElementById('event-card');
      if (wrappedElement.scrollHeight - (wrappedElement.scrollTop + 5) <= wrappedElement.clientHeight) {
        this.offsetNumber += 100;
        this.fetchEventsData(this.systemId);
        // document.removeEventListener('scroll', this.trackScrolling);
      }
    },
     async fetchEventsData(sysId) {
      let apiData = await GlobalService.getEventsList(
        sysId,
        this.userToken,
        this.offsetNumber,
        this.count
      );
      this.eventsData = this.eventsData.concat(apiData);
    },
    compareDates(curr, prev) {
      if (!prev) return false;
      return (
        moment(curr.storedate).format("YYYY-MM-DD") ===
        moment(prev.storedate).format("YYYY-MM-DD")
      );
    },
    showDate(value){
      return moment(value).format("DD/MM/YYYY HH:mm")
    },
    chooseMessage(event) {
      switch (String(event.messagetype)) {
        case "0":
          return "icon-warning-sign";
        case "1":
          return "icon-remove-circle";
        case "2":
          return "icon-check";
        case "3":
          return "icon-check";
        case "4":
          return "icon-remove-circle";
        case "5":
          return "icon-user";
        case "6":
          return "icon-exchange";
        case "7":
          return "icon-exchange";
        default:
          break;
      }
    },
    formatEventDate(event) {
      let translation = {
        Monday: "lng_monday",
        Tuesday: "lng_tuesday",
        Wednesday: "lng_wednesday",
        Thursday: "lng_thursday",
        Friday: "lng_friday",
        Saturday: "lng_saturday",
        Sunday: "lng_sunday"
      };
      let day = moment(event.storedate).format("dddd"); //jshint ignore:line
      return (
        translateFunc([`${translation[day]}`]) +
        " " +
        moment(event.storedate).format("DD/MM-YYYY")
      ); //jshint ignore:line
    },
  },
};
</script>


<style scoped>
.theme--light.v-card > .v-card__text {
  color: #000;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 20px
}
.modal-header {
  position: sticky; 
  top: 0;
  width: 100% !important;
  background: #fff;
  z-index: 9;
}
</style>
